import { useMemo, useState, useLayoutEffect, type ReactElement, type ReactNode } from 'react';

import {
  DEFAULT_CHROME,
  PageChromeContext,
  useChromeContext,
  type Crumb,
  type PageChromeContextValue,
  type PageChromeState,
} from './page-chrome-context';

export function PageChromeProvider({ children }: { children: ReactNode }): ReactElement {
  const [state, setState] = useState<PageChromeState>(DEFAULT_CHROME);
  const value = useMemo<PageChromeContextValue>(() => ({ ...state, set: setState }), [state]);
  return <PageChromeContext.Provider value={value}>{children}</PageChromeContext.Provider>;
}

/** Declarativo: una pantalla monta esto para fijar su breadcrumb/cinta. */
export function PageChrome({
  breadcrumb,
  ribbonRight = null,
  navContext = null,
}: {
  breadcrumb: Crumb[];
  ribbonRight?: string | null;
  navContext?: string | null;
}): null {
  const { set } = useChromeContext();
  useLayoutEffect(() => {
    set({ breadcrumb, ribbonRight, navContext });
    return () => {
      set(DEFAULT_CHROME);
    };
    // Serializa el breadcrumb para no re-disparar por identidad del array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(breadcrumb), ribbonRight, navContext]);
  return null;
}
